import { render, staticRenderFns } from "./area copy.vue?vue&type=template&id=f19c38dc&scoped=true&"
import script from "./area copy.vue?vue&type=script&lang=js&"
export * from "./area copy.vue?vue&type=script&lang=js&"
import style0 from "./area copy.vue?vue&type=style&index=0&id=f19c38dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19c38dc",
  null
  
)

export default component.exports